// extracted by mini-css-extract-plugin
module.exports = {"modal":"ChangeKYBMethod_modal__1QxOy","content":"ChangeKYBMethod_content__1El9D","documentDetails":"ChangeKYBMethod_documentDetails__aIdFv"};